import React from 'react';
import { Box, Button, Container, Divider, Grid, Link, Stack, Typography } from '@mui/material';
import { Email, Facebook, Instagram, LocationOn, Phone, Schedule, WhatsApp } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useBusiness } from '../context/BusinessContext';
import { WHATSAPP_BASE_URL } from '../services/api';
import uploadService from '../services/uploadService';
import DeveloperCredit from './DeveloperCredit';

const PublicFooter = () => {
  const navigate = useNavigate();
  const { businessInfo } = useBusiness();
  const businessName = businessInfo?.businessName || process.env.REACT_APP_SITE_NAME || 'Descorcha2';
  const logo = businessInfo?.logo ? uploadService.getImageUrl(businessInfo.logo) : '/descorcha2-logo.png';
  const phone = businessInfo?.phone || '';
  const whatsapp = businessInfo?.whatsapp || phone;
  const whatsappNumber = whatsapp.replace(/\D/g, '');
  const location = [businessInfo?.address, businessInfo?.city, businessInfo?.province].filter(Boolean).join(', ');

  const goHomeSection = (section) => {
    navigate(`/${section ? `#${section}` : ''}`);
    if (section) {
      window.setTimeout(() => document.getElementById(section)?.scrollIntoView({ behavior: 'smooth' }), 50);
    }
  };

  return (
    <Box component="footer" className="wine-footer public-site-footer">
      <Container maxWidth="lg">
        <Grid container spacing={{ xs: 4, md: 7 }}>
          <Grid item xs={12} md={5}>
            <Box className="public-footer-brand">
              <Box component="img" src={logo} alt={`Logo de ${businessName}`} />
              <Box>
                <Typography component="strong">{businessName}</Typography>
                <Typography component="span">VINOTECA · WINES & DRINKS</Typography>
              </Box>
            </Box>
            <Typography className="public-footer-description">
              {businessInfo?.description || 'Vinos y bebidas seleccionados para cada momento.'}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Typography className="public-footer-title">Navegación</Typography>
            <Stack className="public-footer-links">
              <Button onClick={() => goHomeSection('')}>Inicio</Button>
              <Button onClick={() => navigate('/cava')}>Nuestra cava</Button>
              <Button onClick={() => goHomeSection('contacto')}>Contacto</Button>
              <Button onClick={() => navigate('/login')}>Acceso al sistema</Button>
            </Stack>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Typography className="public-footer-title">Contacto</Typography>
            <Stack spacing={1.5} className="public-footer-contact">
              {businessInfo?.email && <Link href={`mailto:${businessInfo.email}`}><Email />{businessInfo.email}</Link>}
              {phone && <Link href={`tel:${phone}`}><Phone />{phone}</Link>}
              {location && <Link href={`https://maps.google.com/?q=${encodeURIComponent(location)}`} target="_blank" rel="noreferrer"><LocationOn />{location}</Link>}
              {businessInfo?.openingHours && <Typography><Schedule />{businessInfo.openingHours}</Typography>}
              <Box className="public-footer-social">
                {whatsappNumber && <Link href={`${WHATSAPP_BASE_URL}${whatsappNumber}`} target="_blank" rel="noreferrer"><WhatsApp />WhatsApp</Link>}
                {businessInfo?.instagram && <Link href={businessInfo.instagram} target="_blank" rel="noreferrer"><Instagram />Instagram</Link>}
                {businessInfo?.facebook && <Link href={businessInfo.facebook} target="_blank" rel="noreferrer"><Facebook />Facebook</Link>}
              </Box>
            </Stack>
          </Grid>
        </Grid>

        <Divider />
        <Typography className="public-footer-copyright">
          © {new Date().getFullYear()} {businessName}. Todos los derechos reservados.
        </Typography>
        <DeveloperCredit />
      </Container>
    </Box>
  );
};

export default PublicFooter;
